export default "__VITE_ASSET__DvqUw57c__"